module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0009.jpg?v=9d3a42ee";